module.exports = __webpack_public_path__ + "static/img/backdrop-desktop.cd16f21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backdrop-desktop.jpg
// module id = 1151
// module chunks = 5